import { Person, personsConstants } from "../../../../api/Person";
import { useForm } from "react-hook-form";
import { FormButtons } from "../../FormButtons";
import { FormHeader } from "../../FormHeader";
import { QuickAddChildrenProps } from "../common/QuickAddWrapper";
import { InputFormField } from "../../../formfields/InputFormField";
import { useQuickAddSubmit } from "../common/useQuickAddHooks";
import { PersonFieldLabels } from "../../../../api/Person";
import { PersonFormSchema } from "../../../../Persons/PersonForm";
import {
  EntityCustomTypeForm,
  useCustomTypeForm,
  useCustomTypeResolver,
} from "../../../../Customization/CustomTypes/generics/useCustomTypeForm";

export const QuickAddPersonForm = ({ onCreate, onCancel, initialValues }: QuickAddChildrenProps<Person>) => {
  const { onSubmit, loading } = useQuickAddSubmit<Person>({
    resource: personsConstants.resource,
    onCreate: onCreate,
    onCancel: onCancel,
  });
  const { typedResolver } = useCustomTypeResolver<Partial<Person>>(PersonFormSchema);

  // const { defaultValues, typedFormSchema, processCustomFields, type, setType, types } = useCustomTypeForm({
  //   initialValues: {
  //     ...initialValues,
  //     salutation: SALUTATIONS.find((s) => s.name === initialValues?.salutation) as any,
  //   },
  //   formSchema: PersonFormSchema,
  //   typeId: initialValues?.customType?.id,
  //   entityType: "Person",
  //   featureFlag: session?.features.enable_person_custom_types,
  // });

  const {
    reset,
    getValues,
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm<Partial<Person>>({
    defaultValues: initialValues,
    resolver: typedResolver,
  });

  const { processCustomFields, types } = useCustomTypeForm({
    control,
    reset,
    getValues,
    entityType: "Person",
  });

  return (
    <>
      <FormHeader title={"Add person"} subtitle={""} />

      <InputFormField
        id="email"
        label={PersonFieldLabels.email}
        errors={errors}
        register={register}
        placeholder="Enter E-mail address (e.g. support@logs-repository.com) ..."
        autoComplete="email"
      />

      <InputFormField
        id="lastName"
        label={PersonFieldLabels.lastName}
        errors={errors}
        register={register}
        autoFocus
        required
        placeholder="Enter last name..."
        autoComplete="off"
      />

      <InputFormField
        id="firstName"
        label={PersonFieldLabels.firstName}
        errors={errors}
        register={register}
        placeholder="Enter first name..."
        autoComplete="off"
      />

      <EntityCustomTypeForm
        entityType="Person"
        types={types}
        control={control}
        setValue={setValue}
        initialValues={initialValues}
        errors={errors}
        entityConstants={personsConstants}
      />
      <FormButtons
        onClose={onCancel}
        onSubmit={handleSubmit(async (entity) => await onSubmit(processCustomFields(entity)))}
        disabled={isSubmitting}
        errors={errors}
        submitButtonLabel="Create"
        loading={loading}
      />
    </>
  );
};
